import { api_url, dev_shop_host } from "config"
import axios from 'axios';
import { setCache, getCache, removeCache } from "./cache"

class BaseService {

    constructor() {

        var api = axios.create({
            baseURL: api_url,

        });


        api.interceptors.request.use(function (config) {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers.token = token;
            }
            var host = window.location.host;

            host = host.split(":")[0];


            if (dev_shop_host) {
                host = dev_shop_host;
            }




            config.headers.w_url = host;
            //  config.headers.w_id = '15824468';
            return config;
        });


        api.interceptors.response.use(
            (response) => {
                var { data } = response;
                if (data.code == 1)
                    return data.data;
                console.error("api error", data.error)
                return Promise.reject(data.error);
            },
            (error) => {

                return Promise.reject(error);
            }
        );


        this._api = api;
        this.cache = { set: setCache, get: getCache, remove: removeCache };
    }




}
export default BaseService;